import Vue from 'vue'

// 전역 Mixin
Vue.mixin({
    data () {
        return {
            code        : ''
            , basic     : {}
            , baseURI   : ''
            , bannerURL : {
                'plan' : '/plan/item/'
                , 'product' : '/order/direct/'
            }
            , realServer : true 
            , axiosCommonHeader : {
                'X-Requested-With' : 'XMLHttpRequest'
            }
            , cartTotalCnt : cartTotalCnt
            /* view set */
            , viewHome : viewHome 
            , viewCart : viewCart 
            , viewMyOrder : viewMyOrder 
            , viewSohoSearch : viewSohoSearch 
            , viewLogin : viewLogin
            , isLogin : isLogin
            /* view basic url */
            , urlHome : '/'
            , urlCart : '/cart' 
            , urlMyOrder : '/myorder'
            , urlMyPage : '/mypage'
            , urlLogin : '/user/login'
            , urlSohoSearch : sohoSearchUrl
            /* axios url */
            , displayDataUrl : {
                'category'       : '/plan/getCategoryDisplayList'
                , 'topCategory'      : '/plan/getBasicTplTopMenuList'
                , 'product'      : '/main/getList'
                , 'product_best' : '/main/ajaxGetProductBestList'
            }
            /* border checking */
            , bdStr : {
                'top' : 'cont-border-top'
                , 'bottom' : 'cont-border-bottom'
                , 'both' : 'cont-border-both'
                , 'none' : 'cont-border-none'
                , 'banner' : 'cont-border-banner'
            }
        }
    }
    , created () {
        if (process.env.VUE_APP_REAL_SERVER == 'NO') {
            this.realServer = false
        }
    }
    , methods : {
        getSortData () {
            return this.$store.state.sort;
        }
        , getDetailData () {
            return this.$store.state.detail;
        }
        , getDetailDataByCode (code) {
            if (typeof this.$store.state.detail == 'undefined' || typeof this.$store.state.detail[code] == 'undefined') {
                return false;
            }
            return this.$store.state.detail[code];
        }
        , getSkin () {
            return this.$store.state.skin;
        }
        , getDevice () {
            return this.$store.state.device;
        }
        , updateBasicDetailData () {
            if (this.$store.state.updated === false) { return; } 
            if (this.$store.state.updateCode !== this.code) { return; }
            this.basic = this.getDetailDataByCode(this.code);
        }
        , isSetBasicData (key) {
            return (typeof this.basic.data != 'undefined' && typeof this.basic.data[key] != 'undefined')
        }
        , isUse () {
            return (this.basic.use == 'Y')
        }
        , numberFormat (num) {
            return num.toString().replace(/(\d)(?=(?:\d{3})+(?!\d))/g,'$1,');
        }
        , getBannerLink (type, value, id) {
            let link = '';
            let target = '';
            switch (type) {
                case 'plan':
                    link = `${this.baseURI}${this.bannerURL.plan}${id}`;
                    break;
                case 'product':
                    link = `${this.baseURI}${this.bannerURL.product}${id}`;
                    break;
                case 'direct':
                    link = value;
                    target = '_blank';
                    break;
            }
            return { 'link' : link, 'target' : target }
        }
        , isRealServer () {
            return this.realServer
        }
        , getAdminEditMode () {
            return this.$store.state.isAdminEditOn
        }
        , getProductSearchHashTag () {
            return this.$store.state.productSearchHashTag
        }
        , isChangedSearchHashTag () {
            return this.$store.state.changedSearchHashTag
        }
        , controlContentBorder () {
            let bdStr = this.bdStr;
            let borderContent = document.querySelectorAll('.js-border');
            for (let i=0; i < borderContent.length; i++) {
                let target       = borderContent[i]
                let isFirst      = (i == 0) ? true : false
                let targetBefore = (isFirst) ? null : borderContent[i-1]
                let nowClass     = target.classList
                let originBorder
                if (typeof target.dataset.originBorder == 'undefined') {
                    // dataset originBorder 추가.
                    originBorder = 'none';
                    if (nowClass.contains(bdStr['top'])) {
                        originBorder = 'top';
                    } else if (nowClass.contains(bdStr['bottom'])) {
                        originBorder = 'bottom';
                    } else if (nowClass.contains(bdStr['both'])) {
                        originBorder = 'both';
                    } else if (nowClass.contains(bdStr['banner'])) {
                        originBorder = 'banner';
                    }
                    target.dataset.originBorder = originBorder
                } else {
                    originBorder = target.dataset.originBorder
                }
                // origin 복구.
                if (nowClass.contains(bdStr[originBorder]) === false) {
                    for (let j in bdStr) {
                        if (j == originBorder) { continue }
                        if (nowClass.contains(bdStr[j]) === false) { continue }
                        nowClass.remove(bdStr[j])
                    }
                    nowClass.add(bdStr[originBorder])
                }
                // 0번째일 경우 상단 border를 제거. header와 중복.
                if (isFirst === true && nowClass.contains(bdStr['top'])) {
                    nowClass.remove(bdStr['top'])
                }
                // 배너 아래의 경우 무조건 top border를 제거.
                if (isFirst === false && targetBefore.classList.contains(bdStr['banner'])) {
                    nowClass.remove(bdStr['top'])
                }
            }
        }
	}
    , beforeUpdate () {
        this.updateBasicDetailData();
    }
    , updated () {
        this.$store.commit('initUpdateCode');
        if (this.getAdminEditMode()) {
            this.controlContentBorder();
        }
    }
})
